import { types } from 'mobx-state-tree';

import mandatoryId from 'utils/store/mandatoryId';
import AiModuleModel, { createAiModuleModel } from './AiModuleModel';

export const ProjectAiModuleModel = types.model('ProjectAiModuleModel', {
  id: types.identifierNumber,
  additional_input: types.maybe(types.string),
  output: types.maybe(types.string),
  status: types.maybe(types.string),
  error_message: types.maybe(types.string),
  created_at: types.maybe(types.string),
  updated_at: types.maybe(types.string),
  ai_module: types.maybe(AiModuleModel)
});

export const createProjectAiModuleModel = (data?: any): ProjectAiModuleModelType => {
  return ProjectAiModuleModel.create({
    id: mandatoryId(data?.id),
    additional_input: data?.additional_input || undefined,
    output: data?.output || undefined,
    status: data?.status || undefined,
    error_message: data?.error_message || undefined,
    created_at: data?.created_at || undefined,
    updated_at: data?.updated_at || undefined,
    ai_module: data?.ai_module ? createAiModuleModel(data.ai_module) : undefined
  });
};

export type ProjectAiModuleModelType = typeof ProjectAiModuleModel.Type;
export default ProjectAiModuleModel;
